import { AddressDto } from '@act/shared/data-transfer-objects';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import { Box } from '@mui/material';
import { LabeledDatum } from 'toolkit/styles/dataDisplay';
import { CenterVerticalAlign } from './common-layout';

interface AddressEntryProps {
  address: AddressDto;
}

const AddressEntry = ({ address }: AddressEntryProps) => {
  const addressNode = (
    <Box>
      <Box>{address.line1}</Box>
      {address.line2 && <Box>{address.line2}</Box>}
      <Box>
        {address.city}, {address.state} {address.zip}
      </Box>
    </Box>
  );
  const labelComponent = (
    <CenterVerticalAlign>
      {address.description}
      {address.primary && (
        <BeenhereIcon
          fontSize="small"
          color="primary"
          sx={{ marginLeft: '4px' }}
        />
      )}
    </CenterVerticalAlign>
  );
  return <LabeledDatum label={labelComponent} datum={addressNode} />;
};

export default AddressEntry;
